<mf-page title="Nueva empresa">
  <mf-company
    [companyDto]="companyDto"
    (close)="close()"
    (save)="save($event)" />
</mf-page>
